import { NgModule }      from '@angular/core';
import { StateInteractionService }   from '../';
import { EventInteraction } from '../event.interaction.service';

@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ StateInteractionService, EventInteraction ],
  exports:      [ ],
})

export class DynamicInteractionModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/dynamic/module/dynamic.interaction.module.ts